<template>
  <div class="AppointmentList CommonContentSingle-gray">

    <el-drawer title="预约详情" :visible.sync="showViewDetails" :closeCallBack="closeDrawer">
      <el-descriptions  title="用户信息" style="padding-left: 24px;padding-top: 10px;" :column="1">


        <el-descriptions-item label="来访者">{{
          detailsdata.RealName
        }}</el-descriptions-item>
 
        <el-descriptions-item label="联系方式">
        {{
          detailsdata.Phone
        }}</el-descriptions-item>
        <el-descriptions-item label="咨询状态">
          <span style="color: rgba(29, 154, 255, 1);">{{
          detailsdata.Status
        }}</span>
        </el-descriptions-item>

        <el-descriptions-item label="咨询主题">{{
          detailsdata.ConsultTheme
        }}</el-descriptions-item>



        <el-descriptions-item label="问题描述">{{
          detailsdata.ConsultCntIntroduce
        }}</el-descriptions-item>
        <el-descriptions-item label="咨询时间">{{
          detailsdata.ConsultPaperTime
        }}</el-descriptions-item>
        <el-descriptions-item label="咨询地点">{{
          detailsdata.ZXDZ
        }}</el-descriptions-item>

        <el-descriptions-item label="咨询方式">{{
          detailsdata.ConsultType == 1 ? "视频咨询":"面对面咨询"
        }}</el-descriptions-item>

        <el-descriptions-item label="剩余次数">{{
          detailsdata.ResidueCount
        }}</el-descriptions-item>


        <el-descriptions-item label="预约时间">{{
          detailsdata.Yuyue
        }}</el-descriptions-item>

      </el-descriptions>




      <el-descriptions title="咨询评估" style="padding-left: 24px;padding-top: 10px;" :column="1">
        <el-descriptions-item label="1、你是否有过自杀、自伤以及伤害他人的想法或经历： ">{{
          detailsdata.UserName == 1?"是":"否"
        }}</el-descriptions-item>

        <el-descriptions-item label="2、你是否有攻击他人的行为">
        {{
          detailsdata.IsAttack  == 1?"是":"否"
        }}</el-descriptions-item>
        <el-descriptions-item label="3、你是否在精神科就医">{{
           detailsdata.IsSpiritCure  == 1?"是":"否"
        }}</el-descriptions-item>
      </el-descriptions>

      <el-descriptions title="测试评估" style="padding-left: 24px;padding-top: 10px;" :column="1">
        <el-descriptions-item label="SAS 焦虑自评量表">
          {{
          detailsdata.SASResult
        }}
        <span v-if="detailsdata.SASPaperResultID" @click="Gourl(detailsdata.SASPaperResultID)" style="color: rgba(29, 154, 255, 1);cursor:pointer;">查看</span>
        </el-descriptions-item>

        <el-descriptions-item label="SDS 抑郁自评量表">
        {{
          detailsdata.SDSResult
        }}

        <span v-if="detailsdata.SDSPaperResultID" @click="Gourl(detailsdata.SDSPaperResultID)" style="color: rgba(29, 154, 255, 1);cursor:pointer;">查看</span>
        </el-descriptions-item>
      </el-descriptions>


      <el-descriptions title="个人信息" style="padding-left: 24px;padding-top: 10px;" :column="1">
        <el-descriptions-item label="个人信息">{{
          detailsdata.UserName
        }}</el-descriptions-item>

        <el-descriptions-item label="学号">
        {{
          detailsdata.UserID
        }}</el-descriptions-item>
        <el-descriptions-item label="性别">
        {{
          detailsdata.Sex
        }}</el-descriptions-item>
        <el-descriptions-item label="出生日期">
        {{
          detailsdata.Birthday
        }}</el-descriptions-item>
        <el-descriptions-item label="婚姻状态">
        {{
          detailsdata.MarriageState
        }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">
        {{
          detailsdata.Phone
        }}</el-descriptions-item>
        <el-descriptions-item label="身份证号">
        {{
          detailsdata.IDCard
        }}</el-descriptions-item>
        <el-descriptions-item label="所在单位">
        {{
          detailsdata.GraduateSchool
        }}</el-descriptions-item>
        <el-descriptions-item label="培养单位">
        {{
          detailsdata.CultivateUnit
        }}</el-descriptions-item>
      </el-descriptions>


      <el-descriptions title="家庭情况" style="padding-left: 24px;padding-top: 10px;" :column="1">
        <el-descriptions-item label="1、是否是独生子女">{{
          detailsdata.OnlySon   == 1?"是":"否"
        }}</el-descriptions-item>



        <el-descriptions-item v-if="detailsdata.HomeType == 1" label="2、家庭所在地类型">
          乡镇
        </el-descriptions-item>
            <el-descriptions-item v-if="detailsdata.HomeType == 0" label="2、家庭所在地类型">
          城市
        </el-descriptions-item>
            <el-descriptions-item v-if="detailsdata.HomeType == 2" label="2、家庭所在地类型">
          农村
        </el-descriptions-item>



        <el-descriptions-item label="3、是否享受我校贫困生相关政策及补助">
        {{
          detailsdata.IsSubsidy   == 1?"是":"否"
        }}</el-descriptions-item>

        <el-descriptions-item label="4、父亲文化程度">
          {{detailsdata.FatherDegree }}
        </el-descriptions-item>




        <el-descriptions-item label="5、母亲文化程度">
        {{detailsdata.MatherDegree }}
        </el-descriptions-item>





        <el-descriptions-item label="6、目前家庭情况">
        {{
          detailsdata.FamilyStatus
        }}</el-descriptions-item>
        <el-descriptions-item label="7、你如何评价自己家庭的经济状况（1为非常困难，5为非常富裕）">
        {{
          detailsdata.EconStatus
        }}</el-descriptions-item>
        <el-descriptions-item label="8、对家庭的喜欢程度（1为非常厌恶，5为非常喜欢）">
        {{
          detailsdata.LikeLevel
        }}</el-descriptions-item>
        <el-descriptions-item label="9、家庭成员（父系家族及母系家族各三代）有无精神病史">
        {{
          detailsdata.YiYU
        }}</el-descriptions-item>

       
      </el-descriptions>
      <el-descriptions title="操作" style="padding-left: 24px;padding-top: 10px;" :column="1">
           <el-descriptions-item label="是否取消预约">
               <el-button type="primary" @click="AppointRemove()">取消预约</el-button>
           </el-descriptions-item>
           <el-descriptions-item></el-descriptions-item>
           
      </el-descriptions>

    </el-drawer>
    <el-container>
      <el-header
        style="
          background: rgba(255, 255, 255, 1);
          min-height: 80px;
          height: auto;
        "
      >
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          :inline="true"
          class="demo-form-inline"
          style="
            margin: 20px 0px;
            background: rgba(245, 247, 250, 1);
            padding: 10px;
            overflow: hidden;
            height: 42px;
          "
        >
          <el-form-item label="账号">
            <el-input placeholder="账号" v-model="ruleForm.UserID"></el-input>
          </el-form-item>

          <el-form-item label="姓名">
            <el-input placeholder="姓名" v-model="ruleForm.UserName"></el-input>
          </el-form-item>

          <el-form-item label="选择时间">
            <el-date-picker
              v-model="ruleForm.UserTime"
              type="daterange"
              align="right"
              value-format="yyyy-MM-dd"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>

          <el-button
            type="primary"
            @click="resetForm()"
            style="margin-top: 5px; margin-left: 10px"
            >重置</el-button
          >
          <el-button type="primary" @click="onSelect()">查询</el-button>
        </el-form>
      </el-header>

      <el-main style="margin-top: 15px; background: rgba(255, 255, 255, 1)">
        <el-table
          class="Page"
          :data="AppointList"
          style="width: 100%"
          v-loading="IsLoading"
          element-loading-background="rgba(255,255,255,1)"
          element-loading-text="数据正在加载中"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column label="序号" min-width="6%" align="left">
            <template slot-scope="scope" center>
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="UserID"
            label="账号"
            min-width="10%"
          ></el-table-column>
          <el-table-column
            prop="UserName"
            label="姓名"
            min-width="10%"
          ></el-table-column>
          <el-table-column
            prop="ConsultTime"
            label="咨询时间"
            min-width="15%"
          ></el-table-column>

          <el-table-column
            prop="ConAddressName"
            label="咨询地点"
            min-width="20%"
          ></el-table-column>

          <el-table-column
            prop="ConsultType"
            label="咨询方式"
            min-width="8%"
          ></el-table-column>

          <el-table-column
            prop="Status"
            label="预约状态"
            min-width="10%"
          ></el-table-column>

          <el-table-column
            prop="ResidueCount"
            label="预约限制"
            min-width="10%"
          ></el-table-column>

          <el-table-column label="操作" min-width="20%">
            <template slot-scope="scope">
              <el-button size="mini" @click="ViewDetails(scope.row)">
              预约详情
            </el-button>

              <el-button
                v-if="scope.row.YesNO == 'false'"
                size="mini"
                @click="Fillin(scope.$index, scope.row)"
              >
                填写记录
              </el-button>

              <el-button
                v-if="scope.row.YesNO == 'true'"
                size="mini"
                @click="wlooks(scope.$index, scope.row)"
              >
                查看记录
              </el-button>
            <el-tag v-if="AppointList[scope.$index].Status=='未预约'" type="primary" class="eltag" >未预约</el-tag> 
            <el-tag v-if="AppointList[scope.$index].Status=='已预约'" type="info" class="eltag">已预约</el-tag>
            <el-tag v-if="AppointList[scope.$index].Status=='来访者取消'" type="warning" class="eltag">来访者取消</el-tag>
            <el-tag v-if="AppointList[scope.$index].Status=='咨询师取消'" type="warning" class="eltag">咨询师取消</el-tag>
            <el-tag v-if="AppointList[scope.$index].Status=='未来访'" type="danger" class="eltag">未来访</el-tag>
            <el-tag v-if="AppointList[scope.$index].Status=='已来访'" type="success" class="eltag">已来访</el-tag>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="AppointList.length > 0">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage1"
            :page-size="10"
            layout="total, prev, pager, next"
            :total="Counts"
          ></el-pagination>
        </div>
      </el-main>
    </el-container>

    <el-dialog title="预约详情" :visible.sync="dialogVisible" width="50%">
      <div class="app-parent" v-loading="IsDialogLoading" element-loading-background="rgba(255,255,255,1)" element-loading-spinner="el-icon-loading" >
        <div class="app-block">
          <h4>个人信息</h4>
          <ul class="app-ul">
            <li v-for="(value, key, index) in CurrentItem.Basic" :key="index">
              <span>{{ key }}</span>
              :
              <span>{{ value }}</span>
            </li>
          </ul>
        </div>

        <div class="app-block">
          <h4>家庭情况</h4>
          <ul class="app-ul">
            <li v-for="(value, key, index) in CurrentItem.Family" :key="index">
              <span>{{ key }}</span>
              :
              <span>{{ value }}</span>
            </li>
          </ul>
        </div>

        <div class="app-block">
          <h4>咨询问卷</h4>
          <ul class="app-ul">
            <li>
              <span class="app-paper-item">SAS焦虑自评量表测试结果:</span>
              <span
                class="app-paper-res"
                :style="{
                  color:
                    CurrentItem.PaperTestResult.SASScore >= 70
                      ? '#cf0707'
                      : '#07cf94',
                }"
              >
                {{ CurrentItem.PaperTestResult.SASScore }}
              </span>
              <span
                class="app-paper-detail"
                @click="
                  CheckPaperDetail(CurrentItem.PaperTestResult.SASResultID)
                "
              >
                查看详情
              </span>
            </li>
            <li>
              <span class="app-paper-item">SDS抑郁自评量表测试结果:</span>
              <span
                class="app-paper-res"
                :style="{
                  color:
                    CurrentItem.PaperTestResult.SDSScore >= 70
                      ? '#cf0707'
                      : '#07cf94',
                }"
              >
                {{ CurrentItem.PaperTestResult.SDSScore }}
              </span>
              <span
                class="app-paper-detail"
                @click="
                  CheckPaperDetail(CurrentItem.PaperTestResult.SDSResultID)
                "
              >
                查看详情
              </span>
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="WPPdialogVisible"
      width="80%"
      :before-close="handleClose"
    >
      <div class="filein">
        <div class="filein-top">
          <p class="filein-top-p1">
            <span
              >{{ wonedata.UserName }}( <span>来访者</span> )

              <i v-if="wonedata.Zt == 0">未预约</i>

              <i v-else-if="wonedata.Zt == 1">来访者取消</i>
              <i v-else-if="wonedata.Zt == 2">咨询师取消</i>
              <i v-else-if="wonedata.Zt == 3">未来访</i>
              <i v-else-if="wonedata.Zt == 4">已来访</i>
            </span>
          </p>
          <p class="filein-top-p2">
            咨询方式：<span>{{ wonedata.ConsultType }}</span> | 咨询地点：<span
              >{{ wonedata.ConAddressName }}</span
            >
            | 咨询时间：<span>{{ wonedata.ConsultTime }}</span> |
            联系方式：<span>{{ wonedata.Mobile }}</span
            >性别：<span>{{ wonedata.Sex }}</span> | 年龄：
            <span>{{ wonedata.Age }}</span>
          </p>
        </div>
        <div class="filein-button">
          <h2>个人情况</h2>
          <h3>知情同意</h3>
          <el-form
            :inline="true"
            :model="from"
            ref="from"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item
              disabled="true"
              label-width="260px"
              label="保密原则告知和解释（书面和口头）"
              prop="AnswerName1"
            >
              <el-radio-group v-model="from.AnswerName1">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="知情同意讨论（书面和口头）"
              prop="AnswerName2"
            >
              <el-radio-group v-model="from.AnswerName2">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              class="hiucs"
              label="备注"
              label-width="80px"
              style="width: 100%; heighe: 54px"
            >
              <el-input
                style="margin-left: 0px"
                maxlength="500"
                show-word-limit
                type="textarea"
                v-model="from.AnswerName3"
              ></el-input>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important">
              <div
                class="tit"
                style="margin-left: 20px; font-size: 18px; font-weight: 700"
              >
                <span></span>
                <p>来访者问题主诉</p>
              </div>
            </el-form-item>

            <el-form-item label-width="80px" style="width: 100%">
              <p style="margin-left: 20px">
                来访者： <span>{{ wonedata.ConAddressName }}</span
                >,年龄：<span>{{ wonedata.Age }}</span
                >,于<span
                  ><el-input class="qxs1" v-model="from.Riqi"></el-input></span
                >因
                <el-input class="qxs1" v-model="from.AnswerName4"></el-input>
                来寻求咨询帮助，希望咨询师就
                <el-input class="qxs1" v-model="from.AnswerName5"></el-input>
                的问题提供帮助。
              </p>
            </el-form-item>

            <el-form-item
              class="bagtit"
              style="width: 100%; border: none !important"
            >
              <div
                class="tit"
                style="margin-left: 20px; font-size: 18px; font-weight: 700"
              >
                <span></span>
                <p>相关健康史 <span>（重大疾病史）</span></p>
              </div>
            </el-form-item>

            <el-form-item
              label-width="124px"
              class="bvds"
              style="margin-left: 20px"
            >
              <el-input
                maxlength="500"
                show-word-limit
                type="textarea"
                v-model="from.AnswerName7"
              ></el-input>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important">
              <div
                class="tit"
                style="margin-left: 20px; font-size: 18px; font-weight: 700"
              >
                <span></span>
                <p>个人成长史</p>
              </div>
            </el-form-item>

            <el-form-item
              style="width: 100%; border: none !important"
              label-width="40px"
            >
              <h2 style="font-size: 14px">创伤史</h2>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="120px"
              label="重大丧失"
              prop="UserID"
            >
              <el-radio-group v-model="from.AnswerName8">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
                <el-radio label="2">未知</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="120px"
              label="暴力侵害"
              prop="UserID"
            >
              <el-radio-group v-model="from.AnswerName9">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
                <el-radio label="2">未知</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="120px"
              label="性侵害"
              prop="UserID"
            >
              <el-radio-group v-model="from.AnswerName10">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
                <el-radio label="3">尚未评估</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="120px"
              label="被忽视"
              prop="UserID"
            >
              <el-radio-group v-model="from.AnswerName11">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
                <el-radio label="3">尚未评估</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              class="hiucs"
              label="备注"
              label-width="80px"
              style="width: 100%"
            >
              <el-input
                maxlength="500"
                show-word-limit
                type="textarea"
                v-model="from.AnswerName12"
              ></el-input>
            </el-form-item>

            <el-form-item
              label-width="40px"
              style="width: 100%; border: none !important"
            >
              <h2 style="font-size: 14px">家族史</h2>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="120px"
              label="精神病史"
              prop="UserID"
              style="width: 100%"
            >
              <el-radio-group v-model="from.AnswerName13">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
                <el-radio label="2">未知</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="120px"
              label="关系"
              prop="type"
              style="width: 100%"
            >
              <el-checkbox-group v-model="from.AnswerName13_1">
                <el-checkbox label="1000" name="type1">父亲</el-checkbox>
                <el-checkbox label="1001" name="type2">母亲</el-checkbox>
                <el-checkbox label="1002" name="type3">祖父</el-checkbox>
                <el-checkbox label="1003" name="type4">祖母</el-checkbox>
                <el-checkbox label="1004" name="type5">外祖父</el-checkbox>
                <el-checkbox label="1005" name="type6">外祖母</el-checkbox>
                <el-checkbox label="1006" name="type7">其他亲戚</el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="120px"
              label="自杀未遂"
              prop="UserID"
            >
              <el-radio-group v-model="from.AnswerName14">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
                <el-radio label="2">未知</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="120px"
              label="自杀死亡"
              prop="UserID"
            >
              <el-radio-group v-model="from.AnswerName15">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
                <el-radio label="3">尚未评估</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="120px"
              label="暴力攻击倾向"
              prop="UserID"
            >
              <el-radio-group v-model="from.AnswerName16">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
                <el-radio label="3">尚未评估</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="120px"
              label="酒精滥用"
              prop="UserID"
            >
              <el-radio-group v-model="from.AnswerName17">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
                <el-radio label="3">尚未评估</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="120px"
              label="物质滥用"
              prop="UserID"
              style="width: 100%"
            >
              <el-radio-group v-model="from.AnswerName18">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
                <el-radio label="3">尚未评估</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              class="hiucs"
              label="备注"
              label-width="80px"
              style="width: 100%"
            >
              <el-input
                maxlength="500"
                show-word-limit
                type="textarea"
                v-model="from.AnswerName19"
              ></el-input>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important">
              <div class="tit" style="margin-left: 20px">
                <span></span>
                <p style="font-size: 18px; font-weight: 700">状态评估</p>
              </div>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important">
              <div class="tit" style="margin-left: 20px">
                <span></span>
                <p style="font-size: 14px">危机评估</p>
              </div>
            </el-form-item>

            <el-form-item
              disabled="true"
              class="hiucs2"
              label-width="260px"
              label="风险评估及心理干预提示"
              prop="AnswerName4"
              style="width: 100%"
            >
              <el-radio-group v-model="from.AnswerName20" prop="name">
                <el-radio style="padding-top: 10px" label="0"
                  >0 无自我伤害风险(常规性的咨询)</el-radio
                ><br />
                <el-radio style="padding-top: 10px" label="1"
                  >1 有风险但能自控(关注风险的咨询)</el-radio
                ><br />
                <el-radio style="padding-top: 10px" label="2"
                  >2 有风险不能完全自控(制定安全计划、报告相关机构)</el-radio
                ><br />
                <el-radio style="padding-top: 10px" label="3"
                  >3 高风险完全不能自控(紧急综合干预、报告相关机构)</el-radio
                >
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="保护因素评估──咨询/求助动机"
              prop="AnswerName5"
            >
              <el-radio-group v-model="from.AnswerName21">
                <el-radio label="0">强</el-radio>
                <el-radio label="1">弱</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="保护因素评估──家庭支持"
              prop="AnswerName6"
            >
              <el-radio-group v-model="from.AnswerName22">
                <el-radio label="0">强</el-radio>
                <el-radio label="1">弱</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="保护因素评估──社会支持"
              prop="AnswerName7"
            >
              <el-radio-group v-model="from.AnswerName23">
                <el-radio label="0">强</el-radio>
                <el-radio label="1">弱</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="保护因素评估──问题解决能力"
              prop="AnswerName8"
            >
              <el-radio-group v-model="from.AnswerName24">
                <el-radio label="0">强</el-radio>
                <el-radio label="1">弱</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="保护因素评估──活下去的希望"
              prop="AnswerName9"
            >
              <el-radio-group v-model="from.AnswerName25">
                <el-radio label="0">强</el-radio>
                <el-radio label="1">弱</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="保护因素评估──积极的宗教信仰"
              prop="AnswerName10"
            >
              <el-radio-group v-model="from.AnswerName26">
                <el-radio label="0">强</el-radio>
                <el-radio label="1">弱</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="342px"
              label="保护因素评估──不想让有些/某个重要人物失望 "
              prop="AnswerName11"
              style="width: 100%"
            >
              <el-radio-group v-model="from.AnswerName27">
                <el-radio label="0">强</el-radio>
                <el-radio label="1">弱</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              class="svccsc"
              label="保护因素评估──其他相关因素"
              label-width="240px"
              style="width: 100%"
            >
              <el-input
                type="textarea"
                maxlength="500"
                show-word-limit
                v-model="from.AnswerName28"
              ></el-input>
            </el-form-item>

            <el-form-item
              label-width="40px"
              style="width: 100%; border: none !important"
            >
              <h2 style="font-size: 14px">伤害他人危机</h2>
            </el-form-item>

            <el-form-item
              disabled="true"
              class="hiucs2"
              label-width="260px"
              label="风险评估及心理干预提示"
              prop="AnswerName13"
              style="width: 100%"
            >
              <el-radio-group v-model="from.AnswerName29">
                <el-radio style="padding-top: 10px" label="0"
                  >0 无自我伤害风险(常规性的咨询)</el-radio
                ><br />
                <el-radio style="padding-top: 10px" label="1"
                  >1 有风险但能自控(关注风险的咨询)</el-radio
                ><br />
                <el-radio style="padding-top: 10px" label="2"
                  >2 有风险不能完全自控(制定安全计划、报告相关机构)</el-radio
                ><br />
                <el-radio style="padding-top: 10px" label="3"
                  >3 高风险完全不能自控(紧急综合干预、报告相关机构)</el-radio
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item
              disabled="true"
              label-width="260px"
              label="保护因素评估──咨询/求助动机"
              prop="AnswerName14"
            >
              <el-radio-group v-model="from.AnswerName30">
                <el-radio label="0">强</el-radio>
                <el-radio label="1">弱</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="保护因素评估──社会支持"
              prop="AnswerName15"
            >
              <el-radio-group v-model="from.AnswerName31">
                <el-radio label="0">强</el-radio>
                <el-radio label="1">弱</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="保护因素评估──问题解决能力"
              prop="AnswerName16"
            >
              <el-radio-group v-model="from.AnswerName32">
                <el-radio label="0">强</el-radio>
                <el-radio label="1">弱</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="保护因素评估──自知力"
              prop="AnswerName17"
            >
              <el-radio-group v-model="from.AnswerName33">
                <el-radio label="0">强</el-radio>
                <el-radio label="1">弱</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="保护因素评估──自制力"
              prop="AnswerName18"
            >
              <el-radio-group v-model="from.AnswerName34">
                <el-radio label="0">强</el-radio>
                <el-radio label="1">弱</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="保护因素评估──积极的宗教信仰"
              prop="AnswerName19"
            >
              <el-radio-group v-model="from.AnswerName35">
                <el-radio label="0">强</el-radio>
                <el-radio label="1">弱</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              class="svcsscsc"
              label="保护因素评估──其他相关因素"
              label-width="260px"
              prop="AnswerName20"
              style="width: 100%"
            >
              <el-input
                type="textarea"
                maxlength="500"
                show-word-limit
                v-model="from.AnswerName36"
              ></el-input>
            </el-form-item>

            <el-form-item label-width="40px" style="border: none !important">
              <h2 style="font-size: 14px">自我照料危机</h2>
            </el-form-item>

            <el-form-item
              disabled="true"
              class="hiucs2"
              label-width="260px"
              label="自我照料危机"
              prop="UserID"
              style="width: 100%"
            >
              <el-radio-group v-model="from.AnswerName37">
                <el-radio style="padding-top: 10px" label="0"
                  >0 无自我照料问题（正常咨询）</el-radio
                ><br />
                <el-radio style="padding-top: 10px" label="1"
                  >1 自我照料略有不足（关注风险的咨询）</el-radio
                ><br />
                <el-radio style="padding-top: 10px" label="2"
                  >2 自我照料受损明显（制定安全计划、报告相关机构</el-radio
                ><br />
                <el-radio style="padding-top: 10px" label="3"
                  >3 自我照料能力丧失（紧急综合干预、报告相关机构</el-radio
                >
              </el-radio-group>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important">
              <div class="tit" style="margin-left: 20px">
                <span></span>
                <p>一般精神状态评估</p>
              </div>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="焦虑表现与/或症状"
              prop="UserID"
            >
              <el-radio-group v-model="from.AnswerName38">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
                <el-radio label="2">未知</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="注意力缺陷/多动表现与/或症状"
              prop="UserID"
            >
              <el-radio-group v-model="from.AnswerName39">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
                <el-radio label="2">未知</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="抑郁/低落心境表现与/或症状"
              prop="UserID"
            >
              <el-radio-group v-model="from.AnswerName40">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
                <el-radio label="2">未知</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="饮食不规律表现与/或症状"
              prop="UserID"
            >
              <el-radio-group v-model="from.AnswerName41">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
                <el-radio label="2">未知</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="躁狂/轻度躁狂表现与/或症状"
              prop="UserID"
            >
              <el-radio-group v-model="from.AnswerName42">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
                <el-radio label="2">未知</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="精神病性表现与/或症状"
              prop="UserID"
            >
              <el-radio-group v-model="from.AnswerName43">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
                <el-radio label="2">未知</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="自伤倾向表现与/或症状"
              prop="UserID"
            >
              <el-radio-group v-model="from.AnswerName44">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
                <el-radio label="2">未知</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="睡眠问题表现与/或症状"
              prop="UserID"
            >
              <el-radio-group v-model="from.AnswerName45">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
                <el-radio label="2">未知</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="物质滥用史表现与/或症状"
              prop="UserID"
            >
              <el-radio-group v-model="from.AnswerName46">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
                <el-radio label="2">未知</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              label="备注"
              class="hiucs"
              label-width="80px"
              style="width: 100%"
            >
              <el-input
                maxlength="500"
                show-word-limit
                type="textarea"
                v-model="from.AnswerName47"
              ></el-input>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important">
              <div class="tit" style="margin-left: 20px">
                <span></span>
                <p>当前状况及社会功能评估</p>
              </div>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="106px"
              label="社会功能"
              prop="UserID"
            >
              <el-radio-group v-model="from.AnswerName48">
                <el-radio label="极好"></el-radio>
                <el-radio label="好"></el-radio>
                <el-radio label="不好"></el-radio>
                <el-radio label="极差"></el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="106px"
              label="工作状况"
              prop="UserID"
            >
              <el-radio-group v-model="from.AnswerName49">
                <el-radio label="0">极好</el-radio>
                <el-radio label="1">好</el-radio>
                <el-radio label="2">不好</el-radio>
                <el-radio label="3">极差</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="106px"
              label="家庭支持"
              prop="UserID"
            >
              <el-radio-group v-model="from.AnswerName50">
                <el-radio label="0">极好</el-radio>
                <el-radio label="1">好</el-radio>
                <el-radio label="2">不好</el-radio>
                <el-radio label="3">极差</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="106px"
              label="社会支持"
              prop="UserID"
            >
              <el-radio-group v-model="from.AnswerName51">
                <el-radio label="0">极好</el-radio>
                <el-radio label="1">好</el-radio>
                <el-radio label="2">不好</el-radio>
                <el-radio label="3">极差</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="其他" label-width="80px">
              <el-radio-group v-model="from.AnswerName52">
                <el-radio label="0">极好</el-radio>
                <el-radio label="1">好</el-radio>
                <el-radio label="2">不好</el-radio>
                <el-radio label="3">极差</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important">
              <div class="tit" style="margin-left: 20px">
                <span></span>
                <p>来自咨询师的评估印象</p>
              </div>
            </el-form-item>

            <el-form-item label="来访者" label-width="80px" style="width: 100%">
              <p>
                来访者: <span>{{ wonedata.UserName }} </span>因
                <el-input class="qxs1" v-model="from.AnswerName54"></el-input
                >等原因，处于
                <el-input class="qxs1" v-model="from.AnswerName55"></el-input
                >状态，存在<el-input
                  class="qxs1"
                  v-model="from.AnswerName56"
                ></el-input
                >的问题
              </p>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important">
              <div class="tit" style="margin-left: 20px">
                <span></span>
                <p>咨询记录</p>
              </div>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="100%"
              label="咨询主题"
              style="width: 100%"
            >
              <el-checkbox-group
                v-model="from.AnswerName61"
                :max="3"
                style="margin-left: 40px"
              >
                <el-checkbox label="1000" name="type">社交关系</el-checkbox>
                <el-checkbox label="1001" name="type">家庭关系</el-checkbox>
                <el-checkbox label="1002" name="type">学业问题</el-checkbox>
                <el-checkbox label="1003" name="type">感情与性</el-checkbox>
                <el-checkbox label="1004" name="type">焦虑恐惧</el-checkbox>
                <el-checkbox label="1005" name="type">自我评价</el-checkbox>
                <el-checkbox label="1006" name="type">压力应对</el-checkbox>
                <el-checkbox label="1007" name="type">生涯发展</el-checkbox>
                <el-checkbox label="1008" name="type">生命意义</el-checkbox>
                <el-checkbox label="1009" name="type">睡眠问题</el-checkbox>
                <el-checkbox label="1010" name="type">饮食问题</el-checkbox>
                <el-checkbox label="1011" name="type">抑郁悲伤</el-checkbox>
                <el-checkbox label="1012" name="type">强迫现象</el-checkbox>
                <el-checkbox label="1013" name="type">成瘾问题</el-checkbox>
                <el-checkbox label="1014" name="type">冲动易怒</el-checkbox>
                <el-checkbox label="1015" name="type">个性特征</el-checkbox>
                <el-checkbox label="1016" name="type">心理疾病</el-checkbox>
                <el-checkbox label="1017" name="type">躁狂状态</el-checkbox>
                <el-checkbox label="1018" name="type">创伤经历</el-checkbox>
                <el-checkbox label="1019" name="type">时间管理</el-checkbox>
                <el-checkbox label="1020" name="type">毕业困难</el-checkbox>
                <el-checkbox label="1021" name="type">适应不良</el-checkbox>
                <el-checkbox label="1022" name="type">导学关系</el-checkbox>
                <el-checkbox label="1023" name="type">同学关系</el-checkbox>
                <el-checkbox label="1024" name="type">经济困难</el-checkbox>
                <el-checkbox label="1025" name="type">其他问题</el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important">
              <div class="tit" style="margin-left: 20px">
                <span></span>
                <p>本次咨询目标与过程概要</p>
              </div>
            </el-form-item>

            <el-form-item label-width="80px" style="width: 100%">
              <p style="margin-left: 20px">
                针对来访者:
                <el-input class="qxs1" v-model="from.AnswerName62"></el-input
                >的问题/困扰,经与来访者商讨确定本次咨询的目标为
                <el-input class="qxs1" v-model="from.AnswerName6"></el-input>
              </p>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="96px"
              label="采用方法"
              style="width: 100%"
            >
              <el-checkbox-group
                v-model="from.AnswerName64"
                :max="3"
                style="margin-left: 40px"
              >
                <el-checkbox label="1000" name="type">心理教育</el-checkbox>
                <el-checkbox label="1001" name="type">情绪疏导</el-checkbox>
                <el-checkbox label="1002" name="type">认知调整</el-checkbox>
                <el-checkbox label="1003" name="type">行为改变</el-checkbox>
                <el-checkbox label="1004" name="type">家庭会谈</el-checkbox>
                <el-checkbox label="1005" name="type">学业咨询</el-checkbox>
                <el-checkbox label="1006" name="type">现实支持</el-checkbox>
                <el-checkbox label="1007" name="type">安全计划</el-checkbox>
                <el-checkbox label="1008" name="type">放松练习</el-checkbox>
                <el-checkbox label="1009" name="type">医疗转介</el-checkbox>
                <el-checkbox label="1010" name="type">生活方式管理</el-checkbox>
                <el-checkbox label="1011" name="type">其他</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="达成目标" label-width="100px">
              <el-input
                style="width: 400px"
                v-model="from.AnswerName65"
              ></el-input>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="154px"
              label="是否布置家庭作业"
            >
              <el-radio-group v-model="from.AnswerName66">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important">
              <div class="tit" style="margin-left: 20px">
                <span></span>
                <p style="font-size: 22px">
                  改善状况
                  <span style="font-size: 16px; color: rgba(158, 158, 158, 1)"
                    >本次咨询结束后，改善状态如何？</span
                  >
                </p>
              </div>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="100px"
              label="情绪"
              prop="UserID"
            >
              <el-radio-group v-model="from.AnswerName67">
                <el-radio label="0">明显改善</el-radio>
                <el-radio label="1">有所改善</el-radio>
                <el-radio label="2">轻微改善</el-radio>
                <el-radio label="3">无明显改善</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="100px"
              label="认知"
              prop="UserID"
            >
              <el-radio-group v-model="from.AnswerName68">
                <el-radio label="0">明显改善</el-radio>
                <el-radio label="1">有所改善</el-radio>
                <el-radio label="2">轻微改善</el-radio>
                <el-radio label="3">无明显改善</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="100px"
              label="行为"
              prop="UserID"
            >
              <el-radio-group v-model="from.AnswerName69">
                <el-radio label="0">明显改善</el-radio>
                <el-radio label="1">有所改善</el-radio>
                <el-radio label="2">轻微改善</el-radio>
                <el-radio label="3">无明显改善</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              class="bagtit"
              style="width: 100%; border: none !important"
            >
              <div class="tit" style="margin-left: 20px">
                <span></span>
                <p style="font-size: 22px">咨询过程记录</p>
              </div>
              <!-- <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName55"></el-input> -->
            </el-form-item>

            <el-form-item
              label-width="124px"
              class="bvds"
              style="margin-left: 20px"
            >
              <el-input
                maxlength="500"
                show-word-limit
                type="textarea"
                v-model="from.AnswerName70"
              ></el-input>
            </el-form-item>

            <!-- <el-form-item label-width="80px" style="width: 100%;">
            <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName70"></el-input>
          </el-form-item> -->

            <!-- <el-input style="padding-left: 20px;" maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName38"></el-input> -->
          </el-form>
        </div>
      </div>

      <el-button style="margin-left: 20px" @click="dialogVisible = false"
        >取 消</el-button
      >
      <el-button type="primary" @click="dialogV">确 定</el-button>
    </el-dialog>
    <el-dialog
      :visible.sync="WPPdialogVisible2"
      width="80%"
      :before-close="handleClose"
    >
      <div class="filein">
        <div class="filein-top">
          <p class="filein-top-p1">
            <span
              >{{ wonedata.UserName }}( <span>来访者</span> )

              <i v-if="wonedata.Zt == 0">未预约</i>

              <i v-else-if="wonedata.Zt == 1">来访者取消</i>
              <i v-else-if="wonedata.Zt == 2">咨询师取消</i>
              <i v-else-if="wonedata.Zt == 3">未来访</i>
              <i v-else-if="wonedata.Zt == 4">已来访</i>
            </span>
          </p>
          <p class="filein-top-p2">
            咨询方式：<span>{{ wonedata.ConsultType }}</span> | 咨询地点：<span
              >{{ wonedata.ConAddressName }}</span
            >
            | 咨询时间：<span>{{ wonedata.ConsultTime }}</span> |
            联系方式：<span>{{ wonedata.Mobile }}</span
            >性别：<span>{{ wonedata.Sex }}</span> | 年龄：
            <span>{{ wonedata.Age }}</span>
          </p>
          <el-button @click="wexport">导出报告</el-button>
          <!-- <el-button type="primary">打印报告s</el-button> -->
        </div>
        <div class="filein-button">
          <h2>个人情况</h2>
          <h3>知情同意</h3>

          <el-form
            :inline="true"
            :model="from"
            ref="from"
            label-width="100px"
            class="demo-ruleForm"
          >
            <!-- <el-form :inline="true" :model="formInline" class="demo-form-inline"> -->
            <!-- <el-form-item style="width: 100%;" >
            <div class="tit" style="margin-left: -80px;">
              <span></span>
              <p>知情说明（是否保密和知情同意）</p>
            </div>
          </el-form-item> -->

            <el-form-item
              disabled="true"
              label-width="276px"
              label="保密原则告知和解释（书面和口头）"
              prop="AnswerName1"
            >
              <span>{{ wonedata2.AnswerName1 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="234px"
              label="知情同意讨论（书面和口头）"
              prop="AnswerName2"
            >
              <span>{{ wonedata2.AnswerName2 }}</span>
            </el-form-item>

            <el-form-item
              class="hiucs"
              label="备注"
              label-width="80px"
              style="width: 100%"
            >
              <span>{{ wonedata2.AnswerName3 }}</span>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important">
              <div
                class="tit"
                style="margin-left: 20px; font-size: 18px; font-weight: 700"
              >
                <span></span>
                <p>来访者问题主诉</p>
              </div>
            </el-form-item>

            <el-form-item label-width="80px" style="width: 100%">
              <p style="margin-left: 20px">
                来访者：
                <span>{{ wonedata.ConAddressName }}</span
                >,年龄：<span>{{ wonedata.Age }}</span
                >,于<span>时间</span>因
                <span>{{ wonedata2.AnswerName4 }}</span>
                来寻求咨询帮助，希望咨询师就
                <span>{{ wonedata2.AnswerName5 }}</span> 的问题提供帮助。
              </p>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important">
              <div
                class="tit"
                style="margin-left: 20px; font-size: 18px; font-weight: 700"
              >
                <span></span>
                <p>相关健康史 <span>（重大疾病史）</span></p>
              </div>
            </el-form-item>

            <el-form-item label-width="120px" style="margin-left: 20px">
              <span>
                {{ wonedata2.AnswerName7 }}
              </span>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important">
              <div
                class="tit"
                style="margin-left: 20px; font-size: 18px; font-weight: 700"
              >
                <span></span>
                <p>个人成长史</p>
              </div>
            </el-form-item>

            <el-form-item label-width="40px" style="width: 100%;border: none !important">
              <h2 style="font-size: 14px">创伤史</h2>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="100px"
              label="重大丧失"
              prop="UserID"
            >
              <span>
                {{ wonedata2.AnswerName8 }}
              </span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="100px"
              label="暴力侵害"
              prop="UserID"
            >
              <span>{{ wonedata2.AnswerName9 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="100px"
              label="性侵害"
              prop="UserID"
            >
              <span>{{ wonedata2.AnswerName10 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="100px"
              label="被忽视"
              prop="UserID"
            >
              <span>{{ wonedata2.AnswerName11 }}</span>
            </el-form-item>

            <el-form-item
              class="hiucs"
              label="备注"
              label-width="80px"
              style="width: 100%"
            >
              <span>{{ wonedata2.AnswerName12 }}</span>
            </el-form-item>

            <el-form-item
              label-width="40px"
              style="width: 100%; border: none !important"
            >
              <h2 style="font-size: 14px">家族史</h2>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="100px"
              label="精神病史"
              prop="UserID"
              style="width: 100%"
            >
              <span>{{ wonedata2.An13_1 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="100px"
              label="关系"
              prop="type"
              style="width: 100%"
            >
              <span>{{ wonedata2.AnswerName13_1 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="100px"
              label="自杀未遂"
              prop="UserID"
            >
              <span>{{ wonedata2.AnswerName14 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="100px"
              label="自杀死亡"
              prop="UserID"
            >
              <span> {{ wonedata2.AnswerName15 }} </span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="130px"
              label="暴力攻击倾向"
              prop="UserID"
            >
              <span>{{ wonedata2.AnswerName16 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="100px"
              label="酒精滥用"
              prop="UserID"
            >
              <span>{{ wonedata2.AnswerName17 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="100px"
              label="物质滥用"
              prop="UserID"
              style="width: 100%"
            >
              <span>{{ wonedata2.AnswerName18 }}</span>
            </el-form-item>

            <el-form-item
              class="hiucs"
              label="备注"
              label-width="80px"
              style="width: 100%"
            >
              <span>
                {{ wonedata2.AnswerName19 }}
              </span>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important">
              <div class="tit" style="margin-left: 20px">
                <span></span>
                <p style="font-size: 18px; font-weight: 700">状态评估</p>
              </div>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important">
              <div class="tit" style="margin-left: 20px">
                <span></span>
                <p style="font-size: 14px">危机评估</p>
              </div>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="风险评估及心理干预提示"
              prop="AnswerName4"
              style="width: 100%"
            >
              <span>{{ wonedata2.AnswerName20 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="保护因素评估──咨询/求助动机"
              prop="AnswerName5"
            >
              <span>{{ wonedata2.AnswerName21 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="保护因素评估──家庭支持"
              prop="AnswerName6"
            >
              <span>{{ wonedata2.AnswerName22 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="保护因素评估──社会支持"
              prop="AnswerName7"
            >
              <span>{{ wonedata2.AnswerName23 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="保护因素评估──问题解决能力"
              prop="AnswerName8"
            >
              <span>{{ wonedata2.AnswerName24 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="保护因素评估──活下去的希望"
              prop="AnswerName9"
            >
              <span>{{ wonedata2.vvAnswerName25 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="保护因素评估──积极的宗教信仰"
              prop="AnswerName10"
            >
              <span>{{ wonedata2.AnswerName26 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="342px"
              label="保护因素评估──不想让有些/某个重要人物失望 "
              prop="AnswerName11"
              style="width: 100%"
            >
              <span>{{ wonedata2.AnswerName27 }}</span>
            </el-form-item>

            <el-form-item
              class="hiucs"
              label="保护因素评估──其他相关因素"
              label-width="240px"
              style="width: 100%"
            >
              <span>{{ wonedata2.AnswerName28 }}</span>
            </el-form-item>

            <el-form-item label-width="40px" style="width: 100%">
              <h2 style="font-size: 14px">伤害他人危机</h2>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="风险评估及心理干预提示"
              prop="AnswerName13"
              style="width: 100%"
            >
              <span>{{ wonedata2.AnswerName29 }}</span>
            </el-form-item>
            <el-form-item
              disabled="true"
              label-width="260px"
              label="保护因素评估──咨询/求助动机"
              prop="AnswerName14"
            >
              <span>{{ wonedata2.AnswerName30 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="保护因素评估──社会支持"
              prop="AnswerName15"
            >
              <span>{{ wonedata2.AnswerName31 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="保护因素评估──问题解决能力"
              prop="AnswerName16"
            >
              <span>{{ wonedata2.AnswerName32 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="保护因素评估──自知力"
              prop="AnswerName17"
            >
              <span>{{ wonedata2.AnswerName33 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="保护因素评估──自制力"
              prop="AnswerName18"
            >
              <span>{{ wonedata2.AnswerName34 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="260px"
              label="保护因素评估──积极的宗教信仰"
              prop="AnswerName19"
            >
              <span>{{ wonedata2.AnswerName35 }}</span>
            </el-form-item>

            <el-form-item
              label="保护因素评估──其他相关因素"
              label-width="260px"
              prop="AnswerName20"
              style="width: 100%"
            >
              <span>{{ wonedata2.AnswerName36 }}</span>
            </el-form-item>

            <el-form-item label-width="40px">
              <h2 style="font-size: 14px">自我照料危机</h2>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="146px"
              label="自我照料危机"
              prop="UserID"
              style="width: 100%"
            >
              <span>{{ wonedata2.AnswerName37 }}</span>
            </el-form-item>

            <el-form-item style="width: 100%">
              <div class="tit" style="margin-left: 20px">
                <span></span>
                <p>一般精神状态评估</p>
              </div>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="174px"
              label="焦虑表现与/或症状"
              prop="UserID"
            >
              <span>{{ wonedata2.AnswerName38 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="250px"
              label="注意力缺陷/多动表现与/或症状"
              prop="UserID"
            >
              <span>{{ wonedata2.AnswerName39 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="234px"
              label="抑郁/低落心境表现与/或症状"
              prop="UserID"
            >
              <span>{{ wonedata2.AnswerName40 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="212px"
              label="饮食不规律表现与/或症状"
              prop="UserID"
            >
              <span>
                {{ wonedata2.AnswerName41 }}
              </span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="232px"
              label="躁狂/轻度躁狂表现与/或症状"
              prop="UserID"
            >
              <span>{{ wonedata2.AnswerName42 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="198px"
              label="精神病性表现与/或症状"
              prop="UserID"
            >
              <span>{{ wonedata2.AnswerName43 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="198px"
              label="自伤倾向表现与/或症状"
              prop="UserID"
            >
              <span>{{ wonedata2.AnswerName44 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="198px"
              label="睡眠问题表现与/或症状"
              prop="UserID"
            >
              <span>{{ wonedata2.AnswerName45 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="212px"
              label="物质滥用史表现与/或症状"
              prop="UserID"
            >
              <span>{{ wonedata2.AnswerName46 }}</span>
            </el-form-item>

            <el-form-item label="备注" label-width="80px" style="width: 100%">
              <span>{{ wonedata2.AnswerName47 }}</span>
            </el-form-item>

            <el-form-item style="width: 100%">
              <div class="tit" style="margin-left: 20px">
                <span></span>
                <p>当前状况及社会功能评估</p>
              </div>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="106px"
              label="社会功能"
              prop="UserID"
            >
              <span>{{ wonedata2.AnswerName48 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="106px"
              label="工作状况"
              prop="UserID"
            >
              <span>{{ wonedata2.AnswerName49 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="106px"
              label="家庭支持"
              prop="UserID"
            >
              <span>{{ wonedata2.AnswerName50 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="106px"
              label="社会支持"
              prop="UserID"
            >
              <span>{{ wonedata2.AnswerName51 }}</span>
            </el-form-item>

            <el-form-item label="其他" label-width="80px">
              <span>{{ wonedata2.AnswerName52 }}</span>
            </el-form-item>

            <el-form-item style="width: 100%">
              <div class="tit" style="margin-left: 20px">
                <span></span>
                <p>来自咨询师的评估印象</p>
              </div>
            </el-form-item>

            <el-form-item label="来访者" label-width="80px" style="width: 100%">
              <p>
                来访者: <span>{{ wonedata.ConAddressName }} </span>因
                <span>{{ wonedata2.AnswerName54 }}</span> 等原因，处于
                <span>{{ wonedata2.AnswerName55 }}</span
                >状态，存在 <span>{{ wonedata2.AnswerName56 }}</span> 的问题
              </p>
            </el-form-item>

            <el-form-item style="width: 100%">
              <div class="tit" style="margin-left: 20px">
                <span></span>
                <p>咨询记录</p>
              </div>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="96px"
              label="咨询主题"
              style="width: 100%"
            >
              <span>{{ wonedata2.An61 }}</span>
            </el-form-item>

            <el-form-item style="width: 100%">
              <div class="tit" style="margin-left: 20px">
                <span></span>
                <p>本次咨询目标与过程概要</p>
              </div>
            </el-form-item>

            <el-form-item label-width="80px" style="width: 100%">
              <p style="margin-left: 20px">
                针对来访者: <span>{{ wonedata2.AnswerName62 }}</span
                >的问题/困扰,经与来访者商讨确定本次咨询的目标为
                <span>{{ wonedata2.AnswerName63 }}</span>
              </p>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="100%"
              label="采用方法"
              style="width: 100%"
            >
              <span>{{ wonedata2.An64 }}</span>
            </el-form-item>
            <el-form-item label="达成目标" label-width="98px">
              <span>{{ wonedata2.AnswerName65 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="154px"
              label="是否布置家庭作业"
            >
              <span>{{ wonedata2.AnswerName66 }}</span>
            </el-form-item>

            <el-form-item style="width: 100%">
              <div class="tit" style="margin-left: 20px">
                <span></span>
                <p style="font-size: 22px">
                  改善状况
                  <span style="font-size: 16px; color: rgba(158, 158, 158, 1)"
                    >本次咨询结束后，改善状态如何？</span
                  >
                </p>
              </div>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="74px"
              label="情绪"
              prop="UserID"
            >
              <span>{{ wonedata2.AnswerName67 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="74px"
              label="认知"
              prop="UserID"
            >
              <span>{{ wonedata2.AnswerName68 }}</span>
            </el-form-item>

            <el-form-item
              disabled="true"
              label-width="74px"
              label="行为"
              prop="UserID"
            >
              <span>{{ wonedata2.AnswerName69 }}</span>
            </el-form-item>

            <el-form-item style="width: 100%">
              <div class="tit" style="margin-left: 20px">
                <span></span>
                <p style="font-size: 22px">咨询过程记录</p>
              </div>
              <!-- <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName55"></el-input> -->
            </el-form-item>

            <el-form-item
              label-width="80px"
              style="width: 100%; margin-left: 20px"
            >
              <span>{{ wonedata2.AnswerName70 }}</span>
            </el-form-item>

            <!-- <el-input style="padding-left: 20px;" maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName38"></el-input> -->
          </el-form>
        </div>
      </div>
    </el-dialog>
    <el-dialog
    title="取消预约"
      :visible.sync="dialogAlert"
      width="35%"
    >
      <div >
      <el-input
  type="textarea"
  :rows="10"
   
  placeholder="请输入内容"
  v-model="textarea">
</el-input>
<div style="position:relative;text-align:center;">
<el-button type="primary" style="margin-top:15px" @click="submitAppoint()">确认</el-button>
<el-button type="warning" style="margin-top:15px" @click="colseWindows()">关闭</el-button>

</div>

      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      textarea: '',
      wonedata: "",
      wonedata2: "",
      WPPdialogVisible: false,
      WPPdialogVisible2: false,
      dialogAlert: false,
      showViewDetails: false,
      currentPage1: 1,
      Counts: 1,
      pageSize: 10,
      pageIndex: 0,
      DetailsInfo: {
        UserName: "", //来访者
        ConsultTime: "", // 咨询时间
        ConAddressName: "", // 咨询地点
        ConsultType: "", // 咨询方式
        Status: "", // 咨询状态
        ResidueCount: "", // 剩余次数
        SchedulDate: "", // 预约时间
      },
      detailsdata:'',

      from: {
        AnswerName1: "",
        AnswerName2: "",
        AnswerName3: "",
        AnswerName4: "",
        AnswerName5: "",
        AnswerName6: "",
        AnswerName7: "",
        AnswerName8: "",
        AnswerName9: "",
        AnswerName10: "",
        AnswerName11: "",
        AnswerName12: "",
        AnswerName13: "",
        AnswerName13_1: [],
        AnswerName14: "",
        AnswerName15: "",
        AnswerName16: "",
        AnswerName17: "",
        AnswerName18: "",
        AnswerName19: "",
        AnswerName20: "",
        AnswerName21: "",
        AnswerName22: "",
        AnswerName23: "",
        AnswerName24: "",
        AnswerName25: "",
        AnswerName26: "",
        AnswerName27: "",
        AnswerName28: "",
        AnswerName29: "",
        AnswerName30: "",
        AnswerName31: "",
        AnswerName32: "",
        AnswerName33: "",
        AnswerName34: "",
        AnswerName35: "",
        AnswerName35: "",
        AnswerName37: "",
        AnswerName38: "",
        AnswerName39: "",
        AnswerName40: "",
        AnswerName41: "",
        AnswerName42: "",
        AnswerName43: "",
        AnswerName44: "",
        AnswerName45: "",
        AnswerName46: "",
        AnswerName47: "",
        AnswerName48: "",
        AnswerName49: "",
        AnswerName50: "",
        AnswerName51: "",
        AnswerName52: "",
        AnswerName53: "",
        AnswerName54: "",
        AnswerName55: "",
        AnswerName56: "",
        AnswerName57: "",
        AnswerName58: "",
        AnswerName59: "",
        AnswerName60: "",
        AnswerName61: [],
        AnswerName62: "",
        AnswerName63: "",
        AnswerName64: [],
        AppointmentID: "",
        UserID: "",
        Counselor: "",
        Riqi: "",
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      ruleForm: {
        UserID: "",
        UserName: "",
        UserTime: null,
      },

      dialogVisible: false,
      IsLoading: true,
      IsDialogLoading: false,
      AppointList: [
        {
          AppointmentID: "app01",
          SchedulID: "Sch001",
          UserID: "01",
          UserName: "张三",
          Status: "已预约",
          DeptName: "经济管理学院",
          ConsultTime: "2022-02-15 08:00:00-09:00:00",
          AppointmentTime: "2022-02-14 08:25:36",
          ConsultType: "线下咨询",
        },
      ],
      CurrentItem: {
        Basic: {
          姓名: "张三",
          学号: "01",
          性别: "男",
          婚姻状态: "已婚",
          年龄: 30,
          身份证号: "360430189565421563",
          现居住地址: "上海市浦东新区",
          联系电话: "13526545869",
          邮箱: "543166216@126.com",
          汉族: "汉族",
          国家地区: "中国上海",
          宗教信仰: "佛教",
          所在单位: "经济管理学院",
          紧急联系人: "张四",
          联系方式: "13652658965",
          关系: "父亲",
        },
        Family: {
          是否独生子女: "是（自己在家里排行第一）",
          家庭所在地类型: "城市",
          是否享受我校贫困生相关政策及补助: "否",
          父亲文化程度: "初中",
          母亲文化程度: "小学",
          目前家庭情况: "原生家庭",
          你如何评价自己家庭的经济状况: "1分",
          对家庭的喜欢程度: "2分",
          家庭成员: "5分",
        },
        Questionnaire: {
          咨询方式: "视频咨询",
          咨询主题: "恋爱问题",
          问题描述: "送到了飞机拉三等奖来访按时交党费",
          你是否有过自杀及伤害他人的想法或经历: "是",
          你是否有攻击他人的行为: "否",
          你是否曾经在精神科就医: "是",
        },
        PaperTestResult: {
          SASScore: 78,
          SASResultID: "1e611012-178f-420a-8469-d0c2b785330e",
          SDSScore: 65,
          SDSResultID: "1639b50c-b7b5-40e8-a2ea-a2f46c11a1f9",
        },
      },
    };
  },
  components: {},
  created() {
    this.Init();
  },
  methods: {
       closeDrawer(){
            this.showDrawer = false
        },
    Gourl(a){
      // alert(a)
      let routeData = this.$router.resolve({
        path: '/visitors/ReportShow',
        query: { PaperResultID: a },
      })
      window.open(routeData.href, '_blank')
    },
    handleSizeChange(val) {},
    handleCurrentChange(val) {
      this.Init(val);
    },
    wexport() {
      this.$Http_Post("ConsultSubscribe/ExportFile", {
        AppointmentID: this.from.AppointmentID,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          window.location.replace(this.Global.ApiUrl + res.Data);
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },

    Fillin(row, event) {
      this.from.AppointmentID = event.AppointmentID;
      this.from.UserID = event.UserID;
      this.from.Counselor = event.Counselor;
      this.wonedata = event;
      this.WPPdialogVisible = true;
    },
  AppointRemove() {

      this.dialogAlert = true;

    
    },
    submitAppoint(){
         this.$Http_Post("ConsultAppoint/UpdateAppointmentSatus", {
        UserID:this.Global.userID,
        AppointmentID: this.from.AppointmentID,
        text: this.textarea.trim(),
        State:23
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
           this.$message({
            type: "success",
            message: "操作成功",
          });

        } else {
             this.$message.error(res.Message);
          
        }
      });
      this.dialogAlert = false;
    },
    colseWindows(){
   this.dialogAlert = false;

    },
     wexport() {
      this.$Http_Post("ConsultSubscribe/ExportFile", {
        AppointmentID: this.from.AppointmentID,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          window.location.replace(this.Global.ApiUrl + res.Data);
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    wlooks(row, event) {
      this.from.AppointmentID = event.AppointmentID;

      this.wonedata = event;
      this.WPPdialogVisible2 = true;
      var xcscs = {
        AppointmentID: event.AppointmentID,
      };
      this.$Http_Post("ConsultSubscribe/FxConsultAnswer", { from: xcscs }).then(
        (res) => {
          this.$message.closeAll();
          if (res.Code == 200 || res.Code == 0) {
            this.wonedata2 = res.Data;
          } else {
          }
        }
      );
    },
    dialogV() {
      this.$Http_Post("ConsultSubscribe/AddConsultAnswer", {
        from: this.from,
      }).then((res) => {
        this.$message.closeAll();
        if (res.Code == 200 || res.Code == 0) {
          this.WPPdialogVisible2 = false;
          this.WPPdialogVisible = false;
          this.Global.request_successful(res.Message);
        } else {
          this.WPPdialogVisible2 = false;
          this.WPPdialogVisible = false;

          this.Global.request_failure(res.Message);
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    ViewDetails(row) {
      this.showViewDetails = true;
this.from.AppointmentID=row.AppointmentID;
      var csccvsd = {
        "AppointmentID": row.AppointmentID,
      }
      this.$Http_Post("ConsultAppoint/GetappointmentDetails", {
        from: csccvsd,
      }).then((res) => {
        this.$message.closeAll();
        if (res.Code == 200 || res.Code == 0) {
          this.detailsdata = res.Data
        } else {
          this.Global.request_failure(res.Message);
        }
      });


      // this.DetailsInfo.UserName = row.UserName;
      // this.DetailsInfo.ConsultTime = row.ConsultTime;
      // this.DetailsInfo.ConsultType = row.ConsultType;
      // this.DetailsInfo.Status = row.Status;
      // this.DetailsInfo.ResidueCount = row.ResidueCount;
      // this.DetailsInfo.ConAddressName = row.ConAddressName;
      // this.DetailsInfo.SchedulDate = moment
      //   .utc(row.SchedulDate)
      //   .local()
      //   .format("YYYY-MM-DD");
    },
    resetForm() {
      this.ruleForm.UserID = "";
      this.ruleForm.UserName = "";
      this.ruleForm.UserTime = "";
      this.pageIndex = 0;
      this.Init();
    },
    onSelect() {
      if (
        this.ruleForm.UserID == "" &&
        this.ruleForm.UserName == "" &&
        this.ruleForm.UserTime == ""
      ) {
        this.$message({
          message: "您未输入查询条件",
          type: "warning",
        });
      } else {
        this.pageIndex = 0
        let _this = this;
        this.$Http_Post("ConsultAppoint/GetAppointList", {
          UserInfo: _this.ruleForm.UserID,
          CounsultInfo: _this.ruleForm.UserName,
          UserTime: _this.ruleForm.UserTime,
          pageIndex: _this.pageIndex,
          pageSize: 10,
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            _this.AppointList = res.Data;
          } else {
            this.$message.error(res.Message);
          }
        });
      }
    },
    Init() {
       let _this = this;
      this.$Http_Post("ConsultAppoint/GetAppointList", {
        UserInfo: _this.ruleForm.UserID,
        CounsultInfo: _this.ruleForm.UserName,
        SchedulDateFrm: _this.ruleForm.UserTime,
        pageIndex: _this.pageIndex,
        pageSize: 10,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          _this.AppointList = res.Data;
          _this.IsLoading = false;
          this.Counts = Number(res.Counts);
        } else {
          this.$message.error(res.Message);
        }
      });
    },

    CheckPaperDetail(resultid) {
      let routeData = this.$router.resolve({
        path: "/visitors/ReportShow",
        query: { PaperResultID: resultid },
      });
      window.open(routeData.href, "_blank");
    },
    SetVisitState(curItem) {
      let _this = this;
      this.$Http_Post("ConsultAppoint/SetAppointmentState", {
        AppointmentID: curItem.AppointmentID,
        Status: "5",
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.$message({
            type: "success",
            message: "操作成功",
          });
          this.Init();
        } else {
          this.$message.error(res.Message);
        }
      });
    },
  },
};
</script>
<style>
.app-parent {
  height: 100%;
  overflow: auto;
}
.eltag{
    margin-left:5px
}
.app-block {
  padding: 10px;
  line-height: 25px;
  background-color: #ebf5ff;
  border-radius: 5px;
  margin-bottom: 5px;
}

.app-paper-res {
  margin-left: 10px;
}

.app-paper-detail {
  color: blue;
  text-decoration: underline;
  margin-left: 10px;
  cursor: pointer;
}

.fromcss {
  padding: 30px 0px 0px 0px;
}

.AppointmentList .demo-form-inline {
  padding: 24px;
}
.el-drawer__header {
  font-size: 20px;
  margin-bottom: 1px;
}
.filein {
  background-color: rgba(
    239.99999999999997,
    239.99999999999997,
    239.99999999999997,
    1
  );
}
.filein-top {
  height: 170px;
  width: 100%;
  background-color: #fff;
}
.filein-button {
  min-height: 555px;
  margin-top: 20px;
  background-color: #fff;
}
.AppointmentList .el-dialog {
  background-color: rgba(
    239.99999999999997,
    239.99999999999997,
    239.99999999999997,
    1
  );
}
.AppointmentList .el-dialog__header {
  padding: 0px !important;
}
.AppointmentList .el-dialog__body {
  padding-top: 14px;
  background-color: #fff;
}
.filein-top .filein-top-p1 {
  font-size: 20px;
  font-weight: 700;
  padding: 16px;
  width: 270px;
}
.filein-top .filein-top-p2 {
  font-size: 18px;
  padding: 16px;
}
.filein-top .filein-top-p2 span {
  font-size: 16px;
  color: rgba(141, 141, 141, 1);
}
.filein-top i {
  display: inline-block;
  background-color: rgba(29, 154, 255, 1);
  font-size: 14px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  font-weight: 111;
  float: right;
  padding: 1px;
  padding-left: 6px;
  padding-right: 6px;
}
.filein-top em {
  display: inline-block;
  background-color: rgba(21, 191, 109, 1);
  font-size: 14px;
  height: 26px;
  width: 60px;
  line-height: 26px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  font-weight: 111;
}
.filein-top .el-button {
  float: right;
  margin-right: 16px;
}
.filein-button h2 {
  font-size: 24px;
  font-weight: 700;
  padding: 16px;
}
.filein-button h3 {
  font-size: 18px;
  font-weight: 700;
  padding: 16px;
  padding-left: 24px;
  padding-top: 0px;
}

.AppointmentList .el-textarea__inner {
  width: 600px;
}
.AppointmentList .el-input {
  width: 200px;
}
.AppointmentList .el-radio {
  margin-left: 0px;
}

.AppointmentList .el-form--inline .el-form-item {
  border: 1px solid rgba(245, 247, 250, 1);
  width: calc(50 - 2px);
  margin-right: 0px;
}
.AppointmentList .el-dialog__body .el-form-item__label {
  background-color: rgba(245, 247, 250, 1);
  text-align: left;
  text-indent: 24px;
  height: 100%;
}

.AppointmentList .el-dialog__body .el-form-item__label {
  background-color: rgba(245, 247, 250, 1);
  text-align: left;
  text-indent: 24px;
  height: 100%;
}
.AppointmentList .el-dialog__body .el-form--inline .el-form-item {
  width: calc(50% - 20px);
}
.AppointmentList .el-dialog__body .hiucs {
  width: 680px !important;
}
.hiucs .el-form-item__label {
  height: 54px !important;
  line-height: 54px;
}
.AppointmentList .el-dialog__body .el-radio-group {
  margin-left: 50px;
}
.AppointmentList .el-dialog__body .el-textarea__inner {
  margin-left: 0px !important;
}
.AppointmentList .qxs1 .el-input__inner {
  border: none;
  border-bottom: 1px solid rgb(182, 182, 182);
  border-radius: 0px;
}
.AppointmentList .bagtit .el-form-item {
  border: none !important;
}
.AppointmentList .el-dialog__body .bvds {
  width: calc(50% - 40px) !important;
}

.AppointmentList .el-dialog__body .el-checkbox-group {
  margin-left: 20px;
}
.hiucs2 .el-form-item__label {
  height: 106px !important;
  line-height: 106px;
}

.AppointmentList .el-dialog__body .svccsc {
  width: 840px !important;
}
.svccsc .el-form-item__label {
  height: 54px !important;
  line-height: 54px;
}
.AppointmentList .el-dialog__body .svcsscsc {
  width: 860px !important;
}
.svcsscsc .el-form-item__label {
  height: 54px !important;
  line-height: 54px;
}
.AppointmentList .el-dialog__body .el-form-item__content span {
  margin-left: 20px;
}
.AppointmentList .boxs {
  background-color: #fff;
  margin-bottom: 15px;
}
.AppointmentList .boxs button {
  float: right;
  margin-right: 20px;
}
.AppointmentList .boxs2 {
  background-color: #fff;
  height: 620px;
}
.AppointmentList .block {
  float: right;
}
.el-drawer__body tbody td{border:none}
.AppointmentList .el-descriptions-item__label{color:rgba(40, 40, 40, 1);font-size: 16px;}
.AppointmentList .el-descriptions-item__content{color: rgba(141, 141, 141, 1);}
.AppointmentList .el-drawer__open .el-drawer.rtl{width: 40% !important;}
#el-drawer__title{color: #000;font-weight: 700;}
</style>
